import { useLLMContext } from '../contexts/LLMContext'

export function useLLM() {
    return useLLMContext()
}
